import { render, staticRenderFns } from "./atlas_grid.vue?vue&type=template&id=5085d6c2&scoped=true&"
import script from "./atlas_grid.vue?vue&type=script&lang=js&"
export * from "./atlas_grid.vue?vue&type=script&lang=js&"
import style0 from "./atlas_grid.vue?vue&type=style&index=0&id=5085d6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5085d6c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5085d6c2', component.options)
    } else {
      api.reload('5085d6c2', component.options)
    }
    module.hot.accept("./atlas_grid.vue?vue&type=template&id=5085d6c2&scoped=true&", function () {
      api.rerender('5085d6c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/atlas/_tool/atlas_grid.vue"
export default component.exports